const translations = {
  // Geral
  newProcess: 'New',
  home: 'Home',
  login: 'Login',
  register: 'Register',
  logout: 'Logout',
  error: 'Error',
  success: 'Success',
  confirm: 'Confirm',
  cancel: 'Cancel',
  processing: 'Processing...',
  loading: 'Loading...',
  sending: 'Sending...',
  save: 'Save',
  delete: 'Delete',
  back: 'Back',
  allRightsReserved: 'All rights reserved',
  
  // Autenticação
  email: 'Email',
  password: 'Password',
  name: 'Name',
  signUp: 'Sign Up',
  alreadyHaveAccount: 'Already have an account? Log in',
  needAccount: 'Need an account? Sign up',
  forgotPassword: 'Forgot password?',
  resetPassword: 'Reset Password',
  sendResetLink: 'Send Reset Link',
  backToLogin: 'Back to Login',
  resetPasswordEmailSent: 'Reset Password Email Sent',
  checkYourEmail: 'Check your inbox for the reset link',
  signUpSuccess: 'Sign Up Successful',
  passwordTooShort: 'Password must be at least 8 characters',
  passwordRequirements: 'Password must contain lowercase, uppercase, number and symbol',
  passwordPlaceholder: 'Min 8 chars: Aa1@...',
  nameRequired: 'Name is required',
  nameTooShort: 'Name must be at least 2 characters',
  invalidEmail: 'Invalid email format',
  rememberMe: 'Remember me',
  emailAlreadyInUse: 'This email is already in use. Please log in or use a different email.',
  pwReqMinLength: 'At least 8 characters',
  pwReqLowercase: 'One lowercase letter',
  pwReqUppercase: 'One uppercase letter',
  pwReqNumber: 'One number',
  pwReqSymbol: 'One special character (!@#$...)',
  emailConfirmationTitle: 'Check Your Email',
  emailConfirmationDescription: 'We sent a confirmation link to your email. Please check your inbox and click the link to activate your account.',
  emailConfirmationNote: 'Didn\'t receive the email? Check your spam or junk folder.',
  understood: 'Got it',
  resendEmail: 'Resend email',
  resendEmailSuccess: 'Email resent successfully!',
  resendIn: 'Resend in {{seconds}}s',
  resetPasswordDescription: 'We sent a password reset link to your email. Please check your inbox and click the link to reset your password.',
  resetPasswordNote: 'Didn\'t receive the email? Check your spam or junk folder.',
  goToLogin: 'Go to Login',
  createNewPassword: 'Create New Password',
  createNewPasswordDesc: 'Enter your new password below.',
  newPassword: 'New Password',
  confirmPassword: 'Confirm Password',
  passwordsDontMatch: 'Passwords do not match',
  passwordsMatch: 'Passwords match',
  passwordResetSuccess: 'Password Reset Successfully',
  passwordResetSuccessDesc: 'Your password has been changed. You will be redirected to login.',
  linkExpiredTitle: 'Link Expired',
  linkExpiredDescription: 'This recovery link is invalid or has expired. Please request a new link.',
  requestNewLink: 'Request New Link',

  // Conta de usuário
  myAccount: 'My Account',
  userMenu: 'User Menu',
  unnamed: 'Unnamed',
  deleteAccount: 'Delete Account',
  deleteAccountConfirm: 'Delete Account Confirmation',
  deleteAccountWarning: 'Are you sure you want to delete your account?',
  deleteAccountConsequences: 'This action is irreversible and will result in permanent data loss.',
  finalDeleteConfirm: 'Final Account Deletion Confirmation',
  finalDeleteWarning: 'This is your last chance! Deleting your account will:',
  deleteAccountEffect1: 'Remove all your data from our systems.',
  deleteAccountEffect2: 'Cancel any active subscriptions.',
  deleteAccountEffect3: 'Log you out permanently.',
  deleteAccountFinal: 'Yes, Delete My Account',
  accountDeleted: 'Your account has been successfully deleted.',
  
  // Assinatura
  subscriptionPage: 'Subscription',
  availablePlans: 'Available Plans',
  yourSubscription: 'Your Subscription',
  subscriptionStatus: 'Subscription Status',
  subscriptionDetails: 'Subscription Details',
  plan: 'Plan',
  planLabel: 'Plan',
  priceLabel: 'Price',
  currentPeriod: 'Current Period',
  status: 'Status',
  endsAt: 'Ends At',
  cancelSubscription: 'Cancel Subscription',
  subscribe: 'Subscribe',
  manageSubscription: 'Manage Subscription',
  billingHistory: 'Billing History',
  updatePaymentMethod: 'Update Payment Method',
  paymentMethod: 'Payment Method',
  cardNumber: 'Card Number',
  expirationDate: 'Expiration Date',
  cvc: 'CVC',
  update: 'Update',
  saveChanges: 'Save Changes',
  errorFetchingSubscription: 'Failed to fetch subscription data. Please try again later.',
  subscriptionCanceled: 'Subscription Canceled',
  subscriptionResumed: 'Subscription Resumed',
  loadingSubscription: 'Loading subscription data...',
  noActiveSubscription: 'No Active Subscription',
  noActiveSubscriptionDescription: 'You don\'t have an active subscription. Please select a plan to subscribe.',
  viewAvailablePlans: 'View Available Plans',
  
  // Planos
  freePlan: 'Free Plan',
  basicPlan: 'Basic Plan',
  advancedPlan: 'Advanced Plan',
  unlimitedPlan: 'Unlimited Plan',
  freePlanDescription: 'For occasional use and testing',
  basicPlanDescription: 'For individual users',
  advancedPlanDescription: 'For professional users',
  unlimitedPlanDescription: 'For intensive usage',
  labelsPerDay: 'labels/day',
  unlimitedLabels: 'Unlimited conversions',
  freeFeature2: 'Standard support',
  freeFeature3: 'Manual label processing',
  basicFeature2: 'Email support',
  basicFeature3: 'Batch processing',
  advancedFeature2: 'Priority support',
  advancedFeature3: 'Batch processing',
  advancedFeature4: 'History for 90 days',
  unlimitedFeature2: 'Premium support',
  unlimitedFeature3: 'Advanced batch processing',
  unlimitedFeature4: 'Unlimited history',
  month: 'month',
  popularTag: 'Popular',
  freePlanButton: 'Start Free',
  selectPlan: 'Select Plan',
  freePlanSelected: 'Free Plan Selected',
  freePlanSelectedDescription: 'You are now using the free plan with limited features.',
  simplePricing: 'Simple, Transparent Pricing',
  errorProcessingRequest: 'Error processing your request. Please try again.',
  loginRequired: 'You must be logged in to subscribe.',
  
  // Subscrição Success
  subscriptionSuccess: 'Subscription Successful',
  subscriptionSuccessMessage: 'Your subscription was completed successfully.',
  subscriptionThankYou: 'Thank you for your subscription. You now have access to all the features of your selected plan.',
  viewSubscription: 'View Your Subscription',
  
  // Navegação
  accessApplication: 'Access Application',
  goToDashboard: 'Go to Dashboard',
  
  // Upload e Processamento
  dragAndDrop: 'Drag and drop your files here',
  acceptedFormats: 'Accepted formats: .txt, .zpl or .zip with ZPL files',
  selectFile: 'Select File',
  dropHere: 'Drop files here',
  processingZip: 'Processing ZIP file',
  fileUploaded: 'File Uploaded',
  fileProcessed: 'The file {{fileName}} has been processed',
  zipProcessed: 'ZIP Processed',
  zipFilesExtracted: '{{count}} ZPL files extracted',
  noZplFilesInZip: 'No ZPL files found in the ZIP archive',
  noValidZplContent: 'No valid ZPL content found in the file',
  zipProcessingError: 'Error processing the ZIP file',
  readError: 'Read Error',
  readErrorMessage: 'Error reading the file',
  
  // Histórico
  date: 'Date',
  labelCount: 'Label Count',
  historyTable: {
    date: 'Date',
    labels: 'Labels',
    format: 'Format',
    time: 'Time',
    status: 'Status',
  },
  view: 'View',
  download: 'Download',
  viewPdf: 'View PDF',
  close: 'Close',
  downloadUnavailableAfterRefresh: 'Download unavailable after page refresh',
  deleteRecordConfirm: 'Delete Record',
  deleteRecordWarning: 'Are you sure you want to delete this record? This action cannot be undone.',
  
  // Dashboard
  title: 'ZPL Easy',
  subtitle: 'Upload your ZPL files to convert them to PDF format',
  processingHistory: 'Processing History',
  loadingHistory: 'Loading history...',
  noHistory: 'No processing history found',
  totalRecords: 'Total: {{count}} records',
  downloadStarted: 'Download Started',
  downloadStartedDesc: 'Your file download has started',
  
  // Preview & Conversion
  totalLabels: 'Total Labels',
  labelsProcessed: '{{count}} labels processed',
  downloadAgain: 'Download Again',
  printDirect: 'Print',
  process: 'Process',
  converting: 'Converting...',
  successMessage: 'Conversion completed successfully',
  errorMessage: 'Error processing the file',
  mergePdfError: 'Error merging PDF files',
  
  // Feedback
  feedback: 'Contact Us',
  sendFeedback: 'Contact Us',
  feedbackType: 'Subject',
  selectFeedbackType: 'Select subject',
  feedbackMessage: 'Message',
  feedbackMessagePlaceholder: 'Write your message in detail...',
  feedbackSuggestion: 'Suggestion',
  feedbackBug: 'Bug',
  feedbackComplaint: 'Complaint',
  feedbackOther: 'Other',
  requiredFields: 'Required Fields',
  fillAllFields: 'Please fill in all fields.',
  feedbackSent: 'Message Sent!',
  feedbackThankYou: 'Thank you for your message. We will get back to you soon.',
  errorSendingFeedback: 'Error sending message',
  tryAgainLater: 'Try again later or contact us directly.',
  sendFeedbackButton: 'Send Message',
  attachFile: 'Attach the file with the error (optional)',
  attachFileDescription: 'Want to dramatically increase the chances of a quick fix? Attach the ZPL/ZIP file you were trying to process. Without it, we usually cannot reproduce the issue.',
  attachFilePrivacy: 'Used only for technical analysis. We do not share your file.',
  attachFileSelect: 'Select file',
  attachFileBenefit: '✓ Great! This will speed up diagnosis a lot.',
  attachFileTooLarge: 'File too large. The limit is 9MB. Try compressing into a ZIP.',
  attachFileRemove: 'Remove attachment',
  
  // Formato de impressão
  printFormat: 'Print Format',
  standardFormat: 'Standard',
  hdFormat: 'Sharpness+',
  selectPrintFormat: 'Select how you want to print your labels',
  formatDescription: 'Choose the format that best suits your printer',
  hdFormatDescription: 'AI-enhanced sharpness',
  standardFormatDescription: 'Individual labels in sequence',
  hdFormatWarning: 'Note: Sharpness+ is slower',
  hdFormatWarningMessage: 'Sharpness+ mode uses AI to maximize the sharpness of each label. This process may take longer than standard mode.',
  twoColumnToggle: '2 columns (40×25mm)',
  twoColumnHint: 'For 40×25mm Mercado Livre labels. Outputs an 85×25mm PDF with 2 labels side by side (5mm gap).',

  // Label size
  labelSize: 'Label size',
  labelSizeCustom: 'Custom',
  labelWidth: 'Width',
  labelHeight: 'Height',
  labelSizeRangeHint: 'Values between {{min}} and {{max}} cm.',
  
  // Pagination
  previous: 'Previous',
  next: 'Next',
  
  // Multiple file upload
  dragAndDropMultiple: 'Drag and drop your files here (multiple files supported)',
  selectFiles: 'Select Files',
  selectMoreFiles: 'Select More Files',
  filesSelected: '{{count}} files selected',
  processingFiles: 'Processing files...',
  filesProcessed: 'Files Processed',
  multipleFilesExtracted: '{{fileCount}} files processed, {{labelCount}} labels extracted',
  errorProcessingFiles: 'Error processing one or more files',
  
  // File Tray
  fileTray: 'Selected Files',
  viewDetails: 'View details',
  hideDetails: 'Hide',
  file: 'file',
  files: 'files',
  label: 'label',
  labels: 'labels',
  clearAll: 'Clear all',
  clearAllConfirm: 'Clear all files?',
  clearAllConfirmMessage: 'This will remove {{count}} selected file(s). This action cannot be undone.',
  addMoreFiles: 'Add more',
  readyToProcess: 'Ready',
  removeFile: 'Remove file',
  
  // Process Again
  processAgain: 'Reprocess',
  
  // Beta Notice
  betaNotice: '🚧 This tool is in BETA and under DEVELOPMENT. For issues or suggestions, use the Contact Us button.',
  
  // Progress Messages
  progressParsing: 'Analyzing labels...',
  progressConverting: 'Converting {{current}}/{{total}} labels...',
  progressConvertingSimple: 'Converting labels...',
  progressUpscaling: 'Enhancing {{current}}/{{total}} labels...',
  progressUpscalingSimple: 'Enhancing quality...',
  progressOrganizing: 'Organizing PDF...',
  progressUploading: 'Finishing...',
  progressFinalizing: 'Releasing memory...',
  progressComplete: 'Complete!',
  progressStepIndicator: 'Step {{current}} of {{total}}',
  etaSeconds: '~{{seconds}}s remaining',
  etaMinutes: '~{{minutes}}min {{seconds}}s remaining',
  etaFinalizing: 'Finalizing...',
  
  // Donation
  supportProject: 'Support Project',
  support: 'Support',
  donationDescription: 'Your contribution helps keep ZPL Easy free and constantly evolving. Choose an amount to donate:',
  donationHelpMessage: 'Your donation keeps the project free and evolving. Thank you!',
  donateNow: 'Donate Now',
  donateWithCard: 'Donate with Card',
  card: 'Card',
  scanPixQrCode: 'Scan the QR Code with your bank app',
  likedIt: 'Liked it? Consider supporting the project!',
  donationSuccessTitle: 'Thank You for Your Donation!',
  donationThankYouMessage: 'Your generosity helps us continue improving ZPL Easy.',
  donationImpactMessage: 'Your support is essential to keep the tool free and add new features.',
  footerDescription: 'The best platform for ZPL to PDF conversion. Simple, fast and secure.',
  supporter: 'supporter',
  supporters: 'supporters',
  
  // Donation CTA in History
  donationCta: {
    title: 'Support the project!',
    subtitle: 'Contribute via PIX',
    message: 'Scan with your bank app camera',
    otherMethods: 'Other ways to donate',
  },

  // History retention note
  historyRetentionNote: 'Records and files older than 15 days are automatically deleted.',

  // History Stats
  historyStats: {
    summary: 'Summary',
    totalLabels: '{{count}} labels',
    totalConversions: '{{count}} conversions',
  },

  // History Filters
  historyFilters: {
    search: 'Search...',
    allDates: 'All dates',
    today: 'Today',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    allTypes: 'All types',
    standard: 'Standard',
    hd: 'Sharpness+',
  },

  // Bulk Actions
  bulkActions: {
    selected: '{{count}} selected',
    downloadSelected: 'Download',
    deleteSelected: 'Delete',
    clearSelection: 'Clear selection',
    pageSelectedPrompt: 'All {{pageCount}} records on this page are selected.',
    selectAllHistory: 'Select all {{count}} records in history',
    allHistorySelected: 'All {{count}} records in history are selected',
    confirmBulkDeleteTitle: 'Bulk delete records',
    confirmBulkDeleteMessage: 'This will permanently delete {{count}} record(s) and all associated files. This cannot be undone.',
    confirmBulkDeleteAllMessage: 'This will permanently delete your entire history ({{count}} records) and all associated files. This cannot be undone.',
    bulkDeleteSuccess: '{{count}} record(s) deleted successfully',
    bulkDeleteError: 'Error deleting records',
  },

  // Conversion Type
  conversionType: {
    standard: 'Standard',
    hd: 'Sharpness+',
  },

  // History Status
  historyStatus: {
    ready: 'Ready',
    unavailable: 'Unavailable',
  },

  // Processing time
  processingTimeLabel: '{{time}}s',
};

export default translations;

